/**
 * Topbar — header bar inside the authenticated Shell.
 *
 * Minimal by design (TASK-014 scope): title at the left, avatar placeholder
 * + logout button at the right. The Sidebar already exposes a primary logout
 * action; this one is here so users can sign out without locating the
 * sidebar footer (RNF05).
 */
import type { ReactElement } from 'react';
import { LogOut, UserCircle2 } from 'lucide-react';
import { cn } from '@favelafood/shared/lib/cn';
import { useAuth } from '@favelafood/shared/auth/useAuth';

export function Topbar(): ReactElement {
  const logout = useAuth((s) => s.logout);

  return (
    <header
      className="flex h-14 shrink-0 items-center justify-between border-b border-border bg-bg-card px-6"
      aria-label="Cabeçalho"
    >
      <div className="text-sm font-semibold text-white">FavelaFood Admin</div>
      <div className="flex items-center gap-3">
        <span
          className="flex h-9 w-9 items-center justify-center rounded-full bg-bg-hover text-muted"
          aria-hidden="true"
        >
          <UserCircle2 size={22} />
        </span>
        <button
          type="button"
          onClick={logout}
          className={cn(
            'inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm text-muted transition-colors',
            'hover:bg-bg-hover hover:text-white',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
            'focus-visible:ring-offset-2 focus-visible:ring-offset-bg-card',
          )}
        >
          <LogOut size={16} aria-hidden="true" />
          <span>Sair</span>
        </button>
      </div>
    </header>
  );
}
